import classNames from "classnames";
import InputWrapper from "../../../../components/Input/InputWrapper";

const Radio = ({id, formik, settings = {}}) => {
    const groupName = settings.selectedRadioGroup.value;
    return (
        <InputWrapper className="radio">
            <label className="option">
                <input
                    name={groupName}
                    type="radio"
                    checked={formik.values[groupName] === id}
                    onClick={() => formik.setFieldValue(groupName, id)}
                />
                <span className="checkmark"></span>
            </label>

            <div>
                <label className={classNames({"required": settings.required})}>
                    {settings.title}
                </label>

                {settings.description && <p className="description">{settings.description}</p>}
            </div>
        </InputWrapper>
    )
};

export default Radio;